<form-wrapper>
  <div>
    <div class="choice-block">
      <p>2 choix s'offrent à vous :</p>
    </div>
    <div class="choices">
      <div>
        <p>
          <span>1. Il vous manque des informations :</span> sélectionnez
          <span class="first-choice">“Complétion du funnel par le client”</span
          >. <br />Votre client recevra un lien pour compléter les information
          manquantes lui-même. <br />Vous serez notifié lorsqu’il aura terminé
          la souscription.
        </p>
      </div>
      <div>
        <p>
          <span>2. Vous avez rempli toutes les informations :</span>
          sélectionnez <span class="second-choice">“Question suivante”</span>.
          <br />Vous finaliserez la souscription et enverrez à votre client un
          lien de signature des documents.
        </p>
      </div>
    </div>
  </div>
</form-wrapper>

<form-footer
  [hideSendCompletion]="false"
  (prev)="prev()"
  (next)="next()"
  (sendCompletionSubscription)="sendCompletionSubscription()"
></form-footer>
